/**
 * wql
 * @description 科目管理页面配置
 * @Date 2020/10/20
 */
import React from 'react'
import { component_tool, framework_tool } from '../../../../tool';
import {WizClassifySelect, WizTableForm} from '../../../common'
import moment from "moment";

let { WizModal } = component_tool;

//配置项
let componentName = 'trainPath'
const columns = [
  {
    name: "id",
    fromItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "name",
    searchItem: {},
    tableItem: {
      width: 560
    },
  },

  {
    title: "分类",
    name: "categoryId",
    searchItem: {
      type: 'diy',
      diy: WizClassifySelect,
      returnKey: true,
      wizTreeSelectListProps: {
        itemProps: {
          icon: 'unordered-list',
          title: '科目分类',
          tips: '请勾选所属科目分类'
        },
        treeProps: { checkStrictly: true },
        checkable: false
      },
      apiProps: { type: 10,state:1 },
      selectProps: {
        placeholder: '请选择科目分类'
      },
    }
  },

  {
    title: "分类",
    name: "categoryName",
    tableItem: {
      width: 340,
    },
  },

  {
    title: "类型",
    name: "type",
    searchItem: {
      type: 'select'
    },
    tableItem: {
      width: 200
    },
    dict: [
      { code: 1, codeName: '必修' },
      { code: 2, codeName: '选修' }
    ],
  },

  {
    title: "状态",
    name: "state",
    dataIndex: "state",
    dict: [
      { code: 0, codeName: '无效' },
      { code: 1, codeName: '有效' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
    },
  },

];

const templateConfig = {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          buttonSort:['add','delete'],
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['categoryId'] != undefined){
              value['categoryId'] = value['categoryId'][0];
            }
            return value
          },
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: '/credit/subjectList/subjectDetailAdd'
                }
              }
            },
            {
              key: 'delete',
              custom: true,
              params: { icon: 'delete', children: '删除', type: 'danger'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "del",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  if (rows.length < 1){
                    wizNotice.warn("请至少选择一条科目！");
                    return null
                  }
                  let ids = [];
                  for (let i = 0;i< rows.length;i++){
                    ids.push(rows[i].id)
                  }
                  const content = `删除后数据不可恢复，您确定要删除选中的学分科目吗？`;
                  WizModal.confirm({
                    title: '注意', content,
                    onOk: () => {
                      callback && callback({
                        ids: ids
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false
        },
        rowOperateSort:['update','enableOrDisable','look','creditRecordManagement'],
        rowOperateView: [
          {
            key: "update",
            custom: true,
            params: { children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/credit/subjectList/subjectDetailUpd"
              }
            }
          },
          {
            key: "enableOrDisable",
            custom: true,
            params: { children: "启用"},
            textFormat: {
              recordKey: 'state',
              dirt: { 0: '启用', 1: '禁用'}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateState",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['state'] === 0 ? "启用" : "禁用"
                }该学分科目吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      state: record['state'] === 0 ? 1 : 0,
                      id: record.id
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "look",
            custom: true,
            params: { children: "查看"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/credit/subjectList/SubjectInfo"
              }
            }
          },
          {
            key: "creditRecordManagement",
            custom: true,
            params: { children: "学分记录管理"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/credit/subjectList/subjectCreditRecordList"
              }
            }
          }
        ]
      }
    }
  }


const apis = {
  list: {
    path: `subject/pageList`,
    payload: {
      key: `${componentName}@list`,
      apiParams: {}
    }
  },
  updateState:{
    path: `subject/updateState`,
    payload: {
      key: `${componentName}@updateState`,
      apiParams: {}
    }
  },
  del:{
    path: `subject/del`,
    payload: {
      key: `${componentName}@del`,
      apiParams: {}
    }
  },
  exportTrainPathInfo: {
    path: `${componentName}/exportTrainPathInfo`,
    payload: {
      key: `${componentName}@exportTrainPathInfo`,
      apiParams: {}
    }
  },
  getPathContent: {
    path: `${componentName}/getPathContent`,
    payload: {
      key: `${componentName}@getPathContent`,
      apiParams: {}
    }
  }
}

let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
